import { Box, Button, List, ListItem, ListItemButton, ListItemText, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAuth } from '../../AuthContext';

export default function Downloads() {
  const auth = useAuth();
  const [releases, setReleases] = useState([]);

  const fetchReleases = async () => {
    const { status, data } = await auth.request('/api/download/releases', {})
    console.log(data);
    setReleases(data);
  };

  useEffect(() => {
    fetchReleases();
  }, []);

  if (!releases.length) {
    return null;
  }
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Downloads
      </Typography>

      <List>
        {releases.map(release => (
          <ListItem
            key={release.url}
            secondaryAction={
              <Button variant="contained" color="secondary" onClick={() => window.open(release.url)}>Download</Button>
            }
            sx={theme => ({ borderBottom: `1px solid ${theme.palette.divider}` })}
          >
            <ListItemText primary={release.name} secondary={`v${release.version}`} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}